import { render, staticRenderFns } from "./choose-size.vue?vue&type=template&id=4e4e7e7f&scoped=true"
import script from "./choose-size.vue?vue&type=script&lang=js"
export * from "./choose-size.vue?vue&type=script&lang=js"
import style0 from "./choose-size.vue?vue&type=style&index=0&id=4e4e7e7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4e7e7f",
  null
  
)

export default component.exports